import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function EditIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg width={width || 20} height={height || 20} viewBox="0 0 20 20">
      <g transform="translate(-348 -443)">
        <circle
          data-name="Ellipse 61"
          cx={10}
          cy={10}
          r={10}
          transform="translate(348 443)"
          fill={color || "#2f2f2f"}
        />
        <g data-name="Group 763">
          <path
            data-name="Path 10033"
            d="M5.11-7.986L.226-3.1 0-1.094a.422.422 0 00.466.466l2.008-.221 4.887-4.887zm3.642-.335L7.7-9.378a.844.844 0 00-1.194 0l-.994.994 2.25 2.25.994-.994a.844.844 0 00-.003-1.193z"
            transform="translate(358.078 448.538) translate(-4.078 9.087)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
}
